import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from './AnimationVariants';

interface AnimatedBadgeProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
  animate?: boolean;
}

export function AnimatedBadge({ 
  children, 
  icon,
  className = '',
  animate = true
}: AnimatedBadgeProps) {
  return (
    <motion.div 
      className={`inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium relative overflow-hidden ${className}`}
      variants={fadeIn}
      initial={animate ? "hidden" : undefined}
      animate={animate ? "visible" : undefined}
    >
      {/* Animated gradient background */}
      <motion.div
        className="absolute inset-0 rounded-full"
        animate={{
          background: [
            'linear-gradient(90deg, hsl(var(--primary) / 0.15) 0%, hsl(var(--accent) / 0.2) 50%, hsl(var(--primary) / 0.15) 100%)',
            'linear-gradient(90deg, hsl(var(--accent) / 0.2) 0%, hsl(var(--primary) / 0.15) 50%, hsl(var(--accent) / 0.2) 100%)',
            'linear-gradient(90deg, hsl(var(--primary) / 0.15) 0%, hsl(var(--accent) / 0.2) 50%, hsl(var(--primary) / 0.15) 100%)',
          ],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      
      {/* Shimmer effect */}
      <motion.div
        className="absolute inset-0 rounded-full opacity-50"
        animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          background: 'linear-gradient(270deg, transparent, hsl(var(--primary) / 0.3), transparent)',
          backgroundSize: '200% 100%',
        }}
      />
      
      {icon && <span className="shrink-0 relative z-10 text-primary">{icon}</span>}
      <span className="relative z-10 text-primary">{children}</span>
    </motion.div>
  );
}

export default AnimatedBadge;
